/* eslint-disable no-param-reassign */
import produce from 'immer';
import { REQUEST_TAX_RATES, GET_TAX_RATES } from 'src/actions/taxRateActions';

const initialState = {
  items: [],
  isFetching: false,
  message: ''
};

const taxRateReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_TAX_RATES: {
      return produce(state, (draft) => {
        draft.isFetching = true;
      });
    }

    case GET_TAX_RATES: {
      const { taxRates, message } = action.payload;

      return produce(state, (draft) => {
        draft.items = taxRates;
        draft.isFetching = false;
        draft.message = message;
      });
    }

    default: {
      return state;
    }
  }
};

export default taxRateReducer;
